<template>
  <div class="product_detail">
    <combanner></combanner>
    <div class="prod-det-breadcrumb">
      <div class="com-content-1484">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <span class="el-breadcrumb__item" style="display: flex;align-items: center;margin: -3px 10px 0 0;">
            <i class="el-icon-location-outline" style="font-size: 20px"></i>
            当前位置：
          </span>
          <el-breadcrumb-item :to="{ path: '/home' }">网站首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/product/1/null' }">产品中心</el-breadcrumb-item>
          <el-breadcrumb-item v-if="stateProdClass==1" :to="{ path: '/product/1/null' }">产品分类</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ path: '/product/2/null' }">定制化方案</el-breadcrumb-item>
          <el-breadcrumb-item>{{ dataProdAll.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>


    <div class="prod-det-pict com-padding-top-50 com-padding-bottom-50">
      <div class="com-content-1484 com-content">
        <div class="dn-left">
          <div class="dn-top">
            <div class="swiper-container swiper1">
              <div class="swiper-wrapper wrapper1">
                <div class="swiper-slide slide1"
                     v-for="(item, index) in dataProdAll.imgs_path" :key="index">
                  <div class="dp-picture com-size-all">
                    <img v-lazy="stateimgBaseURL+item" alt=""
                         class="dp-img1 com-size-all com-object-fit-cover">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dn-bot">
            <div class="swiper-prev swiper-button">
              <i class="iconfont icon-zuo_0"></i>
            </div>
            <div class="swiper-container swiper1">
              <div class="swiper-wrapper wrapper1">
                <div class="swiper-slide slide1"
                     v-for="(item, index) in dataProdAll.imgs_path" :key="index">
                  <div class="dp-picture com-size-all">
                    <img v-lazy="stateimgBaseURL+item" alt=""
                         class="dp-img1 com-size-all com-object-fit-cover">
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-next swiper-button">
              <i class="iconfont icon-zuo_0-copy"></i>
            </div>
          </div>
        </div>
        <div class="dn-right">
          <div class="dp-ti1">{{ dataProdAll.title }}</div>

          <!--
          <div class="dp-time1">
            <div class="dp-zuo">限时购</div>
            <div class="dp-you">
              <i class="el-icon-time"></i>距离结束还剩0天8小时9分12秒
            </div>
          </div>
          -->
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">

              <div class="swiper-slide slide1">
                <!--                <div class="dn-top">产品特点</div>-->
                <div class="dn-bot">
                  <i class="el-icon-time"></i> {{ dataProdAll.create_time }}
                  <span style="margin: 0 0 0 50px;"><i class="el-icon-document"></i> {{ dataProdAll.number }}</span>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <!--                <div class="dn-top">描述</div>-->
                <div class="dn-bot">{{ dataProdAll.description }}</div>
              </div>
              <!--
              <div class="swiper-slide slide1">
                <div class="dn-top">销售区域</div>
                <div class="dn-bot">{{ dataProdAll.area }}</div>
              </div>
              -->
              <div class="swiper-slide slide1">
                <!--                <div class="dn-top">产品规格</div>-->
                <div class="dn-bot">
                  <div class="dn-list">
                    <div class="dp-pai"
                         v-for="(item, index) in dataProdAll.sku" :key="index">
                      {{ item.modela }}：{{ item.value }}
                    </div>
                  </div>
                </div>
              </div>
              <!--
            <div class="swiper-slide slide1">
              <div class="dn-bot display-flex">
                <div class="dp-a1">产品视频</div>
                <div class="dp-a2">产品说明</div>
              </div>
            </div>
            -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="prod-det-rele com-padding-bottom-90">
      <div class="com-content-1484">
        <div class="dn-upper">
          <div class="dp-ti1">相关产品</div>
        </div>
        <!--
        <div class="dn-center">
          <el-radio-group v-model="modelRadio">
            <el-radio :label="3">所有</el-radio>
            <el-radio :label="6">工具</el-radio>
            <el-radio :label="9">配件</el-radio>
          </el-radio-group>
        </div>
        -->
        <div class="dn-lower com-padding-top-30">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1"
                   v-for="(item, index) in dataProdAll.about" :key="index" @click="clickDetail(item)">
                <div class="dp-picture">
                  <img v-lazy="stateimgBaseURL+item.imga_path" alt=""
                       class="dp-img1 com-size-all com-object-fit-cover">
                </div>
                <div class="dp-word">
                  <div class="dp-ti1">{{ item.title }}</div>
                  <div class="dp-intr1">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prod-det-intr com-padding-bottom-90">
      <div class="com-content-1484">
        <div class="dn-upper">
          <div class="dn-left">
            <div class="dn-top">
              为您推荐
            </div>
            <div class="dn-bot">
              <div class="swiper-container swiper2">
                <div class="swiper-wrapper wrapper2">
                  <div class="swiper-slide slide2"
                       v-for="(item, index) in dataProdAll.put" :key="index" @click="clickDetail(item)">
                    <div class="dp-picture">
                      <img v-lazy="stateimgBaseURL+item.imga_path" alt=""
                           class="dp-img1 com-size-all com-object-fit-cover">
                    </div>
                    <div class="dp-word">
                      <div class="dp-ti1">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dn-right">
            <el-tabs v-model="activeName">
              <el-tab-pane label="商品介绍" name="first">
                <div class="com-richtext1" v-html="dataProdAll.intro"></div>
              </el-tab-pane>
              <el-tab-pane label="规格与包装" name="second">
                <!--
                   <div class="swiper-container swiper2-packing">
                     <div class="swiper-wrapper wrapper2">
                       <div class="swiper-slide slide2">
                         <div class="dp-zuo">蓄电池电压</div>
                         <div class="dp-you">18V</div>
                       </div>
                       <div class="swiper-slide slide2">
                         <div class="dp-zuo">蓄电池电压</div>
                         <div class="dp-you">18V</div>
                       </div>
                       <div class="swiper-slide slide2">
                         <div class="dp-zuo">蓄电池电压</div>
                         <div class="dp-you">18V</div>
                       </div>
                     </div>
                   </div>
                   -->
                <img v-lazy="stateimgBaseURL+dataProdAll.imgc_path" alt="" class="dp-img1 com-size-all">
              </el-tab-pane>
              <el-tab-pane label="爆炸图" name="third">
                <img v-lazy="stateimgBaseURL+dataProdAll.imgb_path" alt="" class="dp-img1 com-size-all">
              </el-tab-pane>
              <el-tab-pane label="资料下载" name="fourth">
                <div class="swiper-container swiper2-download">
                  <div class="swiper-wrapper wrapper2">
                    <div class="swiper-slide slide2"
                         v-for="(item, index) in dataProdAll.advan" :key="index">
                      <div class="dp-zuo"><i class="el-icon-s-order"></i>{{ item.name }}</div>
                      <a :href="stateimgBaseURL+item.path" target="_blank" class="dp-you">下载文档</a>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import {mapState} from 'vuex'

export default {
  data() {
    return {
      product_id: this.$route.params.example_id,
      activeName: 'first',
      dataProdAll: '',
      modelRadio: 3,
      dataProd: [],
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL', 'stateProdClass']),
  },
  created() {
    this.dataRequestproduct_productDetail()
  },
  methods: {
    initSwiper() {
      let mySwiper = new Swiper('.prod-det-pict .dn-left .dn-top .swiper1', {
        // loop: true,
        observer: true,
        observeParents: true,
        autoHeight: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        navigation: {
          prevEl: '.prod-det-pict .dn-left .swiper-prev',
          nextEl: '.prod-det-pict .dn-left .swiper-next',
        },
        thumbs: {
          autoScrollOffset: 1,
          swiper: {
            el: '.prod-det-pict .dn-left .dn-bot .swiper1',
            slidesPerView: 'auto',
            watchSlidesVisibility: true,
            // loop: true,
            observer: true,
            observeParents: true,
            autoHeight: true,
          }
        }
      });
    },
    // GET产品详情
    dataRequestproduct_productDetail() {
      let params = {
        product_id: this.product_id
      }
      this.$api.user.product_productDetail(params).then(res => {
        console.log(res)
        this.dataProdAll = res.data.info
        console.log('dataProdAll:', this.dataProdAll)

        let newmodela = []
        let newvalue = []
        this.dataProdAll.sku.map((item, index) => {
          if (index % 2 == 0) {
            newmodela.push({
              modela: item.modela
            })
          } else {
            newvalue.push({
              value: item.value
            })
          }
        })
        this.dataProdAll.sku = newmodela.map((item, index) => {
          return {...item, ...newvalue[index]};
        });
        console.log(this.dataProdAll.sku);

        this.$nextTick(() => {
          this.initSwiper()
        })
      })
    },
    clickDetail(item) {
      this.$router.push('/product_detail/' + item.example_id)
    },
  }
}
</script>

<style scoped lang="scss">
.prod-det-breadcrumb {
  padding: 20px 0;
}

.prod-det-pict {
  background: $background1;

  .com-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: #FFFFFF;
    padding: 70px;

    .dn-left {
      width: 560px;

      .dn-top {
        border: 1px solid $line1;

        .swiper1 {
          .slide1 {
            height: 560px;
          }
        }
      }

      .dn-bot {
        margin: 25px 0 0;
        display: flex;
        align-items: center;

        .swiper-button {
          cursor: pointer;
          outline: none;
          color: #999999;

          i {
            font-size: 30px;
          }
        }

        .swiper1 {
          width: 110px*5;

          .slide1 {
            width: 100px;
            height: 100px;
            margin: 0 5px;
            border: 1px solid $line1;
            cursor: pointer;

            &.swiper-slide-thumb-active {
              border: 1px solid $color1;
            }
          }
        }
      }
    }

    .dn-right {
      flex: 1;
      padding: 0 0 0 100*$pc-conversion;

      .dp-ti1 {
        color: #000000;
        font-size: 36px;
      }

      .dp-time1 {
        width: 70%;
        background: $color1;
        color: #ffffff;
        display: flex;
        justify-content: space-between;
        padding: 10px;
        margin: 20px 0 0;
      }

      .swiper1 {
        .wrapper1 {
          flex-wrap: wrap;
        }

        .slide1 {
          margin: 20px 0 0;
          //height: auto;

          .dn-top {
            font-size: 16px;
            color: #000000;
            font-weight: 600;
          }

          .dn-bot {
            //border-top: 2px solid #000000;
            //padding: 20px 0 0;
            //margin: 10px 0 0;
            line-height: 26px;
          }

          .dn-list {
            color: #333333;
            border-top: 1px solid $line1;
            padding: 20px 0 0;
          }

          .dp-a1, .dp-a2 {
            width: 250px;
            height: 34px;
            margin: 0 20px 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
          }

          .dp-a1 {
            background: $color1;
          }

          .dp-a2 {
            background: #000000;
          }
        }
      }
    }
  }
}

.prod-det-rele {
  .dn-upper {
    border-bottom: 2px solid #000000;
    margin: 0 0 30px;

    .dp-ti1 {
      width: 240px;
      height: 60px;
      background: $color2;
      color: #FFFFFF;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

  .dn-center {
    margin: 20px 0 30px;
  }

  .dn-lower {
    .swiper1 {
      .wrapper1 {
        flex-wrap: wrap;
      }

      .slide1 {
        width: calc(100% / 5 - 18px);
        height: auto;
        margin: calc(18px / 2);
        //box-shadow: 0 0 10px rgba(0, 0, 0, .4);
        cursor: pointer;
        border: 1px solid $line1;

        .dp-picture {
          //height: 200px;
          height: calc(276 * 350 / 300) + px;
        }

        .dp-word {
          padding: 15px;
          display: none;

          .dp-ti1 {
            font-weight: 600;
            margin: 0 0 5px;
          }

          .dp-intr1 {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.prod-det-intr {

  .dn-upper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .dn-left {
      width: 300px;

      .dn-top {
        font-size: 18px;
        color: #333333;
      }

      .dn-bot {
        margin: 30px 0 0;

        .swiper2 {
          .wrapper2 {
            flex-wrap: wrap;
          }

          .slide2 {
            margin: 0 0 20px;
            cursor: pointer;

            .dp-picture {
              height: 300px;
              //background: $background1;
              border: 1px solid $line1;
            }

            .dp-word {
              text-align: center;
              font-size: 16px;
              margin: 20px 0;
            }
          }
        }
      }
    }

    .dn-right {
      flex: 1;
      padding: 0 0 0 170*$pc-conversion;

      ::v-deep .el-tabs {
        .el-tabs__header {
          .el-tabs__item {
            padding: 0 50px;

            &:nth-child(2) {
              padding-left: 0;
            }
          }
        }
      }

      .swiper2-packing {
        .wrapper2 {
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .slide2 {
          width: calc(100% / 2 - 10%);
          margin: 10px calc(10% / 2) 10px 0;
          display: flex;
          align-items: center;

          .dp-zuo {
            color: #999999;
            width: 50%;
          }

          .dp-you {
            background: $background1;
            width: 50%;
            padding: 15px 45px;
          }
        }
      }

      .swiper2-download {
        .wrapper2 {
          flex-wrap: wrap;
        }

        .slide2 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid $line1;
          padding: 20px 0;

          .dp-zuo {
            color: #999999;
            display: flex;
            align-items: center;

            i {
              color: $color1;
              font-size: 20px;
              margin: 0 5px 0 0;
            }
          }

          .dp-you {
            color: #000000;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .prod-det-pict {
    .com-content {
      flex-wrap: wrap;
      padding: 70*$mobile-conversion;

      .dn-left {
        width: 100%;

        .dn-top {
          .swiper1 {
            .slide1 {
              height: 90vw;
            }
          }
        }

        .dn-bot {
          margin: 25*$mobile-conversion 0 0;

          .swiper-button {
            i {
              font-size: 50*$mobile-conversion;
            }
          }

          .swiper1 {
            width: 130*$mobile-conversion*4;

            .slide1 {
              width: 120*$mobile-conversion;
              height: 120*$mobile-conversion;
              margin: 0 5*$mobile-conversion;
            }
          }
        }
      }

      .dn-right {
        flex: inherit;
        padding: 0;
        margin: 20*$mobile-conversion 0 0;

        .dp-ti1 {
          font-size: 38*$mobile-conversion;
        }

        .dp-time1 {
          width: 100%;
          padding: 10*$mobile-conversion;
          margin: 20*$mobile-conversion 0 0;
        }

        .swiper1 {

          .slide1 {
            margin: 20*$mobile-conversion 0 0;

            .dn-top {
              font-size: 26*$mobile-conversion;
            }

            .dn-bot {
              line-height: 40*$mobile-conversion;
            }

            .dn-list {
              padding: 20*$mobile-conversion 0 0;

              .dp-pai {
                width: 100% !important;
              }
            }

          }
        }
      }
    }
  }
  .prod-det-rele {
    .dn-upper {
      margin: 0 0 30*$mobile-conversion;

      .dp-ti1 {
        width: 240*$mobile-conversion;
        height: 80*$mobile-conversion;
        font-size: 28*$mobile-conversion;
      }
    }

    .dn-center {
      margin: 20*$mobile-conversion 0 30*$mobile-conversion;
    }

    .dn-lower {
      .swiper1 {

        .slide1 {
          width: calc(100% / 2 - 20 * $mobile-conversion);
          margin: calc(20 * $mobile-conversion / 2);

          .dp-picture {
            height: 300*$mobile-conversion;
          }

          .dp-word {
            padding: 15*$mobile-conversion;

            .dp-ti1 {
              margin: 0 0 5*$mobile-conversion;
            }

          }
        }
      }
    }
  }
  .prod-det-intr {
    .dn-upper {
      flex-wrap: wrap;

      .dn-left {
        width: 100%;

        .dn-top {
          font-size: 28*$mobile-conversion;
        }

        .dn-bot {
          margin: 30*$mobile-conversion 0 0;

          .swiper2 {
            .slide2 {
              width: calc(100% / 2 - 20 * $mobile-conversion);
              margin: 0 10*$mobile-conversion 20*$mobile-conversion;

              .dp-picture {
                height: 300*$mobile-conversion;
              }

              .dp-word {
                font-size: 26*$mobile-conversion;
                margin: 20*$mobile-conversion 0;
              }
            }
          }
        }
      }

      .dn-right {
        flex: inherit;
        padding: 0;
        width: 100%;

        ::v-deep .el-tabs {
          .el-tabs__header {
            .el-tabs__item {
              padding: 0 20*$mobile-conversion;
            }
          }
        }

        .swiper2-packing {

          .slide2 {
            width: calc(100% / 1);
            margin: 10*$mobile-conversion 0;

            .dp-you {
              padding: 15*$mobile-conversion 45*$mobile-conversion;
            }
          }
        }

        .swiper2-download {
          .slide2 {
            padding: 20*$mobile-conversion 0;

            .dp-zuo {
              i {
                font-size: 30*$mobile-conversion;
                margin: 0 5*$mobile-conversion 0 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
